import {
  postAxios
} from "../common/req.js"
export async function newCategory(data) {
  return postAxios({
    url: '/index/news/category',
    data
  })
}



//////////////////
// WEBPACK FOOTER
// ./api/newCategory.js
// module id = n1R6
// module chunks = 14